import {
  FETCH_SERVICES, FETCH_SERVICES_SUCCESS, FETCH_SERVICES_FAILURE,
  SELECT_DEVICES, CHOOSE_REASONS,
  SUBMIT_RETURN_ORDER, SUBMIT_RETURN_ORDER_SUCCESS, SUBMIT_RETURN_ORDER_FAILURE,
  RESET_CONFIRMATION,
} from '../actions/order';

const INITIAL_STATE = {
  services: [],
  devices: [],
  confirmation: false,
  loading: true,
  requested: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SERVICES:
      return { ...state, loading: true, requested: true };
    case FETCH_SERVICES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_SERVICES_FAILURE:
      return {
        ...state, services: null, loading: false, error: action.payload,
      };
    case SELECT_DEVICES:
      return { ...state, selectedDevices: action.payload };
    case SUBMIT_RETURN_ORDER:
      return { ...state, submitLoading: true };
    case SUBMIT_RETURN_ORDER_SUCCESS:
      return {
        ...state,
        selectedDevices: false,
        submitLoading: false,
        confirmation: { ...action.payload },
        trackingId: action.payload.trackingId,
      };
    case SUBMIT_RETURN_ORDER_FAILURE:
      return { ...state, submitError: action.payload, submitLoading: false };
    case RESET_CONFIRMATION:
      return { ...state, confirmation: false };
    case CHOOSE_REASONS:
      return {
        ...state,
        selectedDevices: state.selectedDevices.map(device => ({
          ...device,
          returnReason: action.payload[device.serialNumber],
        })),
      };
    default:
      return state;
  }
}
